import type { ReactNode } from "react"
import { Faq, FAQsTwoColumnAccordion } from "@/components/marketing/sections/faqs-two-column-accordion"
import { Faq as FaqAccordion, FAQsAccordion } from "@/components/marketing/sections/faqs-accordion"
import { PricingFaqAnswer } from "@/components/marketing/PricingFaqAnswer"
import { MARKETING_FAQS } from "@/content/marketing/site-content"

function renderFaqAnswer(id: string, answer: ReactNode) {
  if (id === "faq-pricing") {
    return <PricingFaqAnswer />
  }
  return answer
}

export function MarketingFaqsTwoColumn() {
  return (
    <FAQsTwoColumnAccordion id="faqs" headline="Questions & Answers">
      {MARKETING_FAQS.map((item) => (
        <Faq
          key={item.id}
          id={item.id}
          question={item.question}
          answer={renderFaqAnswer(item.id, item.answer)}
        />
      ))}
      <Faq id="faq-pricing" question="How does pricing work?" answer={<PricingFaqAnswer />} />
    </FAQsTwoColumnAccordion>
  )
}

export function MarketingFaqsAccordion() {
  return (
    <FAQsAccordion id="faqs" headline="Questions & Answers">
      {MARKETING_FAQS.map((item) => (
        <FaqAccordion
          key={item.id}
          id={item.id}
          question={item.question}
          answer={renderFaqAnswer(item.id, item.answer)}
        />
      ))}
      <FaqAccordion id="faq-pricing" question="How does pricing work?" answer={<PricingFaqAnswer />} />
    </FAQsAccordion>
  )
}
